import { release } from '@awayfl/swf-loader';
var CONSTANTNames = [
    'Undefined',
    'Utf8|ClassSealed',
    'Float|ClassFinal',
    'Int',
    'UInt|ClassInterface',
    'PrivateNs',
    'Double',
    'QName',
    'Namespace|ClassProtectedNs',
    'Multiname',
    'False',
    'True',
    'Null',
    'QNameA',
    'MultinameA',
    'RTQName',
    'RTQNameA',
    'RTQNameL',
    'RTQNameLA',
    'NameL',
    'NameLA',
    'NamespaceSet',
    'PackageNamespace',
    'PackageInternalNs',
    'ProtectedNamespace',
    'ExplicitNamespace',
    'StaticProtectedNs',
    'MultinameL',
    'MultinameLA',
    'TypeName'
];
export function getCONSTANTName(constant) {
    return release ? String(constant) : CONSTANTNames[constant];
}
